import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, API_BASE } from "@/lib/api";

const SettingsCtx = createContext(null);

function resolveUrl(u) {
  if (!u) return null;
  if (u.startsWith("http") || u.startsWith("data:")) return u;
  if (u.startsWith("/api/uploads/")) return `${API_BASE.replace(/\/api$/, "")}${u}`;
  return u;
}

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    site_name: "MOBIKAR",
    tagline: "Votre mobilité, notre engagement",
    primary_color: "#0a1e3f",
    secondary_color: "#d4a437",
    accent_color: "#0e7a3f",
    contact_email: "mobikarafrique@gmail.com",
    contact_phone: "",
    address: "",
    logo_url: "",
    banner_url: "",
    social_facebook: "",
    social_instagram: "",
    social_linkedin: "",
    social_twitter: "",
  });

  const refresh = useCallback(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Apply branding to <html>: title, favicon, CSS variables
  useEffect(() => {
    if (settings.site_name) {
      document.title = `${settings.site_name} — ${settings.tagline || ""}`.trim().replace(/—\s*$/, "");
    }
    const root = document.documentElement;
    if (settings.primary_color) root.style.setProperty("--mbk-navy", settings.primary_color);
    if (settings.secondary_color) root.style.setProperty("--mbk-gold", settings.secondary_color);
    if (settings.accent_color) root.style.setProperty("--mbk-green", settings.accent_color);
    // Favicon: prefer explicit favicon_url, fallback to logo, then bundled asset
    const favUrl = resolveUrl(settings.favicon_url) || resolveUrl(settings.logo_url) || "/mobika-icon.png";
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = favUrl;
  }, [settings]);

  return (
    <SettingsCtx.Provider value={{ settings, refresh, setSettings }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);
